import {
	createStyles,
	makeStyles,
} from '@mui/styles';
import {
	Theme,
} from '@mui/material/styles';

const useStyles = makeStyles((theme: Theme) => {

	return createStyles({
		inputSwitch_base: {
			color: theme.palette.grey[200],
		}
	});
})

export default useStyles;
